import { render, staticRenderFns } from "./receive-record.vue?vue&type=template&id=39b1064e&scoped=true"
import script from "./receive-record.vue?vue&type=script&lang=js"
export * from "./receive-record.vue?vue&type=script&lang=js"
import style0 from "./receive-record.vue?vue&type=style&index=0&id=39b1064e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1064e",
  null
  
)

export default component.exports